import React from "react";
import Dispatcher from "../../../dispatcher";
import BookmarkAction from "../../../actions/bookmark-action";
import BookmarkStore from "../../../stores/bookmark-store";
import BookStore from "../../../stores/book-store";

var Menu = require("../../ui_elements/menu").Menu;
var MenuMixin = require("../../ui_elements/menu").MenuMixin;
var MenuList = require("../../ui_elements/menu-list");
var MenuHeader = require("../../ui_elements/menu-header");
var Isvg = require("../../../../vendor/react-inlinesvg");
var BookmarkMenuItem = require("./bookmark-menu-item");

/*
  Renders the bookmarks panel
    props:
    state:
*/
class BookmarksContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bookmarkItems: []
    };

    // MenuMixin methods
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Callback bindings
    this._bookmarksChanged = this._bookmarksChanged.bind(this);
    this._addBookmarkButton = this._addBookmarkButton.bind(this);
    this.addBookmark = this.addBookmark.bind(this);
    this._goToBookmark = this._goToBookmark.bind(this);
    this._removeBookmark = this._removeBookmark.bind(this);
  }

  componentDidMount() {
    // Get bookmarks, then filter them into friendlier data format and save to state
    // Need to also wrap page breaks, since page number is dependent on it
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 2);
    Dispatcher.bind(Dispatcher.BOOKMARKS_CHANGE, this._bookmarksChanged);
    Dispatcher.bind(Dispatcher.BOOKMARKS_ACTION_FAILED, this._bookmarksChanged);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.BOOKMARKS_CHANGE, this._bookmarksChanged);
    Dispatcher.unbind(
      Dispatcher.BOOKMARKS_ACTION_FAILED,
      this._bookmarksChanged
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 2);
  }

  _bookmarksChanged() {
    let bookmarks = BookmarkStore.getAll(this.props.isbn).bookmarks;
    Fraction.Helpers.removeLoader("#bookmark-menu-mobile");
    this.setState({ bookmarkItems: bookmarks });
  }

  _addBookmarkButton(e) {
    Fraction.Helpers.addLoader("#bookmark-menu-mobile", "padding-top:65px;");
    BookmarkAction.addBookmark(this.props.isbn);
  }

  addBookmark(e) {
    BookmarkAction.addBookmark(this.props.isbn);
  }

  _goToBookmark(e, bookmark) {
    e.preventDefault();
    let book = BookStore.get(this.props.isbn);
    // If not clicking on delete button, actually go to the bookmark
    book.viewer.Book.goToBookmark(bookmark, function() {});
    this._removeMenu();
  }

  _removeBookmark(bookmark) {
    var guid = bookmark.guid;

    BookmarkAction.removeBookmark(this.props.isbn, guid);

    $(".bookmark-list-" + guid).css("min-height", "0px");
    $(".bookmark-list-" + guid).slideUp({
      duration: 125,
      queue: false,
      step: () => {
        this.forceUpdate();
      }
    });
  }

  render() {
    const bookmarks = BookmarkStore.getAll(this.props.isbn).bookmarks;
    const bookIsMarked = bookmarks && bookmarks.length > 0;
    let bookmarkItems = [
      {
        html: (
          <BookmarkMenuItem
            key={"bookmark-menu-item-0"}
            addBookmark={this.addBookmark}
          />
        )
      }
    ];

    if (bookIsMarked) {
      bookmarkItems = bookmarks.map(
        function(bookmark) {
          return {
            html: (
              <BookmarkMenuItem
                key={"bookmark-menu-item" + bookmark.guid}
                bookmark={bookmark}
                goToBookmark={this._goToBookmark}
                removeBookmark={this._removeBookmark}
              />
            )
          };
        }.bind(this)
      );
    }

    return (
      <Menu
        key={this.props.menuID}
        className="bookmarks-menu"
        menuId={this.props.menuID}
        direction="down"
        yOffset={this.props.yOffset || -4}
        xOffset={this.props.xOffset || -2}
      >
        {bookIsMarked && (
          <MenuHeader>{i18n.t("reader.panels.bookmarks")}</MenuHeader>
        )}
        <MenuList key="notebook-filter-menu-list" items={bookmarkItems} />
        <div className="mobile-add-bookmark-container">
          <button
            className="submit add-bookmark"
            onClick={this._addBookmarkButton}
          >
            {this.state.showMobileLoading && (
              <div className="small-loader">
                <Isvg src="/img/loader_small.svg">
                  <img src={"/img/loader_small.png"} />
                </Isvg>
              </div>
            )}
            <span>{i18n.t("bookmarks.add-bookmark")}</span>
          </button>
        </div>
      </Menu>
    );
  }
}

module.exports = BookmarksContainer;
